import { Routes } from '@angular/router';
import { AppRouteSegment } from './consts/routes.consts';

export const routes: Routes = [
  {
    path: AppRouteSegment.Root,
    loadChildren: () => import('./external-payment/external-payment.routes').then((m) => m.routes),
  }
];
